import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  DataGrid,
  ruRU,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@material-ui/data-grid";
import { Button } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Select } from "../tools/SelectorOrText/Select";
import ArrowBackIcon from "@material-ui/icons/ArrowBack.js";

import {
  selectCompany,
  setSelectedCompanies,
} from "../../redux/reducers/chart-reducer";

import { useRedirect } from "../../hooks/useRedirect";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import { RouteNames } from "../../router/consts";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  selectOption: {
    backgroundColor: theme.palette.common.white,
    width: 175,
  },
  selectOutlined: {
    padding: "8.5px 35px 8.5px 10px",
  },
}));

const CustomToolbar = (chartDetail, contractorName) => {
  const classes = useStyles();
  const { companies, selectedCompany } = useSelector(selectCompany);

  const dispatch = useDispatch();


  const { redirect } = useRedirect();
  let { chartId } = useParams();
  const onPaste = async (e) => {
    redirect(RouteNames.CHART_PAGE);
  };

  return (
    <GridToolbarContainer>
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          {chartId ? (
            <Button onClick={onPaste}>
              <ArrowBackIcon fontSize="small" />
            </Button>
          ) : null}

          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
        </Grid>
      </Grid>


    </GridToolbarContainer>
  );
};

export const TopTable = ({ data, columns, chartDetail, contractorName }) => {
  const { redirect } = useRedirect();

  const onChartClick = async (e) => {
    const chartId = e.row.id;
    redirect(RouteNames.CHART_DETAIL, { chartId });
  };

  return (
    <Paper style={{ height: "1300px", width: "100%" }}>
      <DataGrid
        rows={data?.map((el, index) => ({ ...el, sequenceNumber: index + 1 }))}
        columns={columns}
        components={{
          Toolbar: () => CustomToolbar(chartDetail, contractorName),
        }}
//        onRowClick={chartDetail ? null : onChartClick}
        density={"standart"}
        localeText={
          ruRU?.props?.MuiDataGrid?.localeText ||
          ruRU?.components?.MuiDataGrid?.defaultProps?.localeText
        }
        disableSelectionOnClick
        disableColumnMenu
        cell--textRight
      />
    </Paper>
  );
};